<template>
    <a-modal
        title="选择班级"
        :visible="visible"
        class="modal-initialize"
        width="508px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item label="班级" v-bind="formItemLayout">
                        <a-select
                            show-search
                            :filter-option="filterOption"
                            style="width: 100%;"
                            v-decorator="['cbid',{rules: [{ required: true, message: '请选择班级' }]} ]"
                            placeholder="请选择班级"
                        >
                            <a-select-option v-for="(item, key) in config.class" :key="item.cbid" :value="item.cbid">
                                {{ item.cname }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rid: {
            type: String,
            default: ''
        },
        ssid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            config: [],
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
            let data = {};

            this.http('/manage/class/class', data, (res) => {
                this.config = res.config;
            });
        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        let url = '';

                        if (this.rid) {
                            url = '/manage/resume/class';
                            values.rid = this.rid;
                        } else if (this.ssid) {
                            url = '/manage/student/class';
                            values.ssid = this.ssid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    }
}
</script>